export const displayDetailsPanelContainerSelector = ({displayDetailsPanelContainer}) => displayDetailsPanelContainer